import { withI18n } from 'react-i18next';
import CheckPrintable from './CheckPrintable';

export const pureComponent = CheckPrintable;
export default withI18n()(CheckPrintable);
